var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrierIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(-294 -171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(294 171)",
    fill: "#8fbe6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MDI_domain",
    "data-name": "MDI / domain",
    transform: "translate(296.433 173.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.133,
    height: 8.133,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.133,
    height: 7.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_domain",
    "data-name": "Path / domain",
    d: "M7.422,7.067H6.744v.678h.678m0-2.033H6.744v.678h.678M8.1,8.422H5.389V7.744h.678V7.067H5.389V6.389h.678V5.711H5.389V5.033H8.1M4.711,4.356H4.033V3.678h.678m0,2.033H4.033V5.033h.678m0,2.033H4.033V6.389h.678m0,2.033H4.033V7.744h.678M3.356,4.356H2.678V3.678h.678m0,2.033H2.678V5.033h.678m0,2.033H2.678V6.389h.678m0,2.033H2.678V7.744h.678M5.389,4.356V3H2V9.1H8.778V4.356Z",
    transform: "translate(-1.322 -1.983)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierIcon);
export default __webpack_public_path__ + "static/media/carrier-icon.a735ec03859ea1a911dca428d335eb54.svg";
export { ForwardRef as ReactComponent };